export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'f7fe6608-5a39-4196-a3b4-29d0872ba146';
export const MODAL_CLOSE_SEC = 2.5;
